import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getOnboardingData } from "@/lib/services";

interface Props {
  children: JSX.Element;
}

export default function OnboardingRequiredRoute({ children }: Props) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [needsOnboarding, setNeedsOnboarding] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const status = await getOnboardingData();
        if (mounted) {
          setNeedsOnboarding(!status.onboarding_completed);
        }
      } catch (_) {
        // If status fails, allow access to avoid lockout and rely on other guards
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) return null; // or a small loader UI
  if (needsOnboarding) {
    return <Navigate to="/onboarding" state={{ from: location }} replace />;
  }
  return children;
}

